import { FF, FieldSet, MultiSelect, NumberInput, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { useTemplateManageContext } from '~bank-document-templates/manage/context'

export const Contact = () => {
  const { formApi, data } = useTemplateManageContext()
  const { contactTypeOptions } = data

  return (
    <FieldSet legend="Contact">
      <FormRow>
        <Col>
          <formApi.Field
            name="contactTypes"
            validators={{
              onChange: ({ value, fieldApi }) => {
                const level = fieldApi.form.getFieldValue('level')
                if (level === 'contact') {
                  return Validators.required.field(value)
                }
                return undefined
              }
            }}
            children={(field) => (
              <FF
                required={field.form.getFieldValue('level') === 'contact'}
                field={field}
                label="Type(s)"
                input={(p) => (
                  <MultiSelect
                    {...p}
                    data={contactTypeOptions}
                    data-qa="Type(s)"
                    hint="Select one or more contact types"
                  />
                )}
              />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name="minimalOwnershipPercent"
            children={(field) => (
              <FF
                field={field}
                label="Minimal ownership percent"
                input={(p) => <NumberInput {...p} data-qa="Minimal ownership percent" />}
              />
            )}
          />
        </Col>
      </FormRow>
    </FieldSet>
  )
}
